module.exports = {
          srcSet: "/_next/static/images/microsoft-teams-48-493db4b0544f443af8bc02b2df554b34.webp"+" 48w",
          images:[ {path: "/_next/static/images/microsoft-teams-48-493db4b0544f443af8bc02b2df554b34.webp",width: 48,height: 48}],
          src: "/_next/static/images/microsoft-teams-48-493db4b0544f443af8bc02b2df554b34.webp",
          toString:function(){return "/_next/static/images/microsoft-teams-48-493db4b0544f443af8bc02b2df554b34.webp"},
          
          width: 48,
          height: 48
        }